export default function Vision() {
  return (
    <section className="scroll-animate py-32 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden">
      {/* Subtle dot pattern background */}
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: `radial-gradient(circle, #94a3b8 1px, transparent 1px)`,
        backgroundSize: '30px 30px'
      }}></div>

      <div className="relative z-10 max-w-6xl mx-auto px-20">
        {/* Top: Large icon */}
        <div className="flex justify-center mb-8">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <div className="absolute inset-0 bg-blue-500 opacity-20 rounded-full animate-ping"></div>
            <div className="relative w-20 h-20 flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 rounded-full">
              <i className="ri-lightbulb-flash-line text-4xl text-white"></i>
            </div>
            <div className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center bg-teal-500 rounded-full">
              <i className="ri-global-line text-lg text-white"></i>
            </div>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-5xl font-bold text-slate-900 text-center mb-8">
          Our Vision
        </h2>

        {/* Body text with emphasis */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <p className="text-xl text-slate-600 leading-relaxed">
            We envision a world where <span className="text-blue-600 font-semibold">geographical boundaries</span> don't limit business opportunities. Through <span className="text-blue-600 font-semibold">AI-powered automation</span> and <span className="text-blue-600 font-semibold">intelligent matching</span>, we're building the infrastructure for truly global commerce—where any business can operate anywhere, and every expert can serve clients worldwide.
          </p>
        </div>

        {/* Bottom: 3 Icon Boxes */}
        <div className="grid grid-cols-3 gap-8">
          {/* Box 1: Hyperlocal Matching */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <div className="mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/2d3e7b24f7bffe8c086aa32f57cf7df0.jpg"
                alt="Hyperlocal Matching"
                className="w-full h-48 object-cover rounded-xl"
              />
            </div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full">
                <i className="ri-map-pin-user-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Hyperlocal Matching</h3>
            </div>
            <p className="text-base text-slate-600 leading-relaxed">
              Connect clients with verified local experts in any market. Our AI understands cultural nuances, language requirements, and regulatory contexts to ensure perfect matches.
            </p>
          </div>

          {/* Box 2: AI Automation */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <div className="mb-6">
              <img 
                src="https://readdy.ai/api/search-image?query=illustration%20of%20robot%20arm%20and%20human%20hand%20collaborating%20together%2C%20AI%20and%20human%20partnership%20concept%2C%20purple%20gradient%20background%2C%20modern%20tech%20illustration%20showing%20automation%20and%20human%20cooperation%2C%20clean%20minimalist%20design%20with%20geometric%20elements%20representing%20workflow%20automation%20and%20intelligent%20assistance&width=400&height=280&seq=vision-ai-automation&orientation=landscape"
                alt="AI Automation"
                className="w-full h-48 object-cover rounded-xl"
              />
            </div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full">
                <i className="ri-robot-2-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">AI Automation</h3>
            </div>
            <p className="text-base text-slate-600 leading-relaxed">
              Eliminate repetitive tasks with intelligent automation. From document processing to workflow management, our AI handles the heavy lifting so professionals can focus on high-value work.
            </p>
          </div>

          {/* Box 3: Scalability */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <div className="mb-6">
              <img 
                src="https://readdy.ai/api/search-image?query=abstract%20illustration%20of%20expanding%20network%20grid%20with%20growing%20nodes%20and%20connections%2C%20scalability%20concept%20with%20geometric%20patterns%2C%20teal%20gradient%20background%2C%20modern%20tech%20visualization%20showing%20business%20growth%20and%20infrastructure%20expansion%2C%20clean%20design%20with%20interconnected%20elements%20representing%20global%20reach&width=400&height=280&seq=vision-scalability&orientation=landscape"
                alt="Scalability"
                className="w-full h-48 object-cover rounded-xl"
              />
            </div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                <i className="ri-stack-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Scalability</h3>
            </div>
            <p className="text-base text-slate-600 leading-relaxed">
              Built for growth from day one. Our infrastructure scales seamlessly from individual consultants to enterprise deployments, supporting millions of transactions across global markets.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
